import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearDeterminate(): React.JSX.Element {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(oldProgress => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
        // variant="determinate"
        value={progress}
        sx={{
          '& .MuiLinearProgress-bar': {
            // backgroundColor: '#FF5C12', // Change the background color of the progress bar
            background: 'linear-gradient(90deg, #FFC38B 0%, #FF8C5A 100%)',
          },
        }}
        // style={{ color: '#FF5C12' }}
      />
    </Box>
  );
}
